import { getUrlParameter } from "./functions.js";

$(document).ready(function () {
  $(".news-more-btn").click(function (evt) {
    evt.preventDefault();

    const parent = $(this).parents("#pdopage");
    const pagination = parent.find(".pagination");
    const lastPageItem = pagination.find(".page-item:last-child");
    const pageLink = lastPageItem.find(".page-link");
    pageLink.click();

    const page = +getUrlParameter("page") > 0 ? +getUrlParameter("page") : 1;
    const pageCount = $(this).data("pagecount");
    if (page == pageCount) {
      $(this).hide();
    }
  });

  if ($(".news-more-btn").length) {
    $(document).on("pdopage_load", function (e, config, response) {
      const page = +getUrlParameter("page") > 0 ? +getUrlParameter("page") : 1;
      let title = document.title;
      const ogTitle = $('meta[property="og:title"]');
      const twitterTitle = $('meta[property="twitter:title"]');
      const dcTitle = $('meta[name="DC.Title"]');

      if (document.title.includes("|")) {
        title = document.title.split("|");
        if (page > 1) {
          title[title.length - 1] = " Страница " + page;
          const joinTitle = title.join("|");
          ogTitle.attr("content", joinTitle);
          twitterTitle.attr("content", joinTitle);
          dcTitle.attr("content", joinTitle);
          document.title = joinTitle;
        } else {
          ogTitle.attr("content", title[0]);
          twitterTitle.attr("content", title[0]);
          dcTitle.attr("content", title[0]);
          document.title = title[0];
        }
      } else {
        if (page > 1) {
          const titleWithPage = title + " | Страница " + page;
          ogTitle.attr("content", titleWithPage);
          twitterTitle.attr("content", titleWithPage);
          dcTitle.attr("content", titleWithPage);
          document.title = titleWithPage;
        } else {
          ogTitle.attr("content", title);
          twitterTitle.attr("content", title);
          dcTitle.attr("content", title);
          document.title = title;
        }
      }
    });
  }
});
